import React from 'react';
import NoData from '../../Assets/Images/Shared/401-2.svg';
import {LoadableImageComponent} from "../LoadableImage/LoadableImage.Componant";
import PropTypes from "prop-types";
import './Errors.Style.scss';

export const ErrorsComponent = ({message, errorCode}) => {
    return (
        <div className="errors-component-wrapper">
            <LoadableImageComponent src={NoData} alt="No Data"/>
            <div className="fz-30px c-danger">{errorCode}</div>
            <div className="c-black-light">{message || "Sorry, you don't have permissions to access this page."}</div>
        </div>
    );
};
ErrorsComponent.propTypes = {
    message: PropTypes.string,
    errorCode: PropTypes.string
}
ErrorsComponent.defaultProps = {
    message: undefined,
    errorCode: '401',
}